import { render, staticRenderFns } from "./Advise.vue?vue&type=template&id=104bdf6e&scoped=true&"
import script from "./Advise.vue?vue&type=script&lang=ts&"
export * from "./Advise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104bdf6e",
  null
  
)

export default component.exports